import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { authApi, authBaseUrl } from "./axiosInstance";
import { normaliseLoginName } from "../config/countryCallingCodes";

// A mobile number may be typed with spaces or dashes ("+44 7911 123456"); it is stored without them
export const login = (data) => authApi.post("/login", { ...data, username: normaliseLoginName(data.username) });
// One-time code from the FEED WORLD website (Components/SsoWebsiteLogin.jsx)
export const websiteLogin = (code) => authApi.post("/sso/website-login", { code });
export const register = (data) => authApi.post("/register", data);
// Forgot password (Components/ForgotPassword.jsx): { login } → a 6-digit code;
// then { login, code, password, confirmPassword } → the new password.
// Plain axios (no interceptors): public calls, so a leftover expired token in this tab must not be sent
// (the server would refuse it) nor trigger the refresh / back-to-sign-in handling.
export const forgotPassword = (data) => axios.post(`${authBaseUrl}/password/forgot`, { ...data, login: normaliseLoginName(data.login) });
export const resetPassword = (data) => axios.post(`${authBaseUrl}/password/reset`, { ...data, login: normaliseLoginName(data.login) });
export const authToken = () => {
  const token = sessionStorage.getItem("accessToken");
  return authApi.get("/authentication/token", {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// Ends the login on the server too (feed POST /user/logout removes this session's tokens). It needs the
// account id, which is the refresh token's subject (the email on tokens issued before). (It used to call "/logout", which doesn't exist,
// so the tokens stayed valid until they expired.)
export const logoutApi = () => {
  const token = sessionStorage.getItem("accessToken");
  const refresh = sessionStorage.getItem("refreshToken");
  let username = null;
  try {
    username = refresh ? jwtDecode(refresh).sub : null;
  } catch (e) {
    username = null;
  }
  if (!token || !username) return Promise.resolve();
  return authApi.post("/user/logout", { username: String(username) }, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

//refresh token API call
export const refreshToken = (refreshToken) => {
  return authApi.post("/refresh/token", { token: refreshToken });
};